import React, { useEffect } from 'react';
import { captureEvent } from '@/posthog-analytics/posthog';

interface NotFoundProps {
  message?: string; // Optional message prop
  description?: React.ReactNode;
  showHomeButton?: boolean;
  reason?: string;
}

const NotFound: React.FC<NotFoundProps> = ({
  message,
  description,
  showHomeButton = true,
  reason,
}) => {

  useEffect(() => {
    captureEvent('page_not_found', {
      attempted_path: window.location.pathname,
      referrer: document.referrer || 'direct',
      is_ats_route: window.location.pathname.startsWith('/ats'),
      reason: reason ?? 'unknown_route',
    });
  }, [reason]);

  const handleGoHome = () => {
    window.location.href = '/'; // Navigates to the home page or specify another route if needed
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen  text-primary-900 px-6 text-center bg-secondary">
      <span className="text-[100px] tracking-widest text-primary">404 </span>
      <h1 className="text-4xl font-semibold mb-4 text-primary">
        {message || 'This Page is Out of Reach'}{' '}
        {/* Use the message prop if provided */}
      </h1>
      <p className="text-lg mb-8 max-w-md leading-relaxed text-gray-600">
        {description ||
          "Looks like this page wandered off... or maybe it never existed! Let's head back to safety."}
      </p>
      {showHomeButton && (
        <button
          onClick={handleGoHome}
          className="px-6 py-3 bg-black hover:bg-primary text-white  font-medium rounded-md transition duration-200 shadow-md transform hover:scale-105"
        >
          Go Back To Safety
        </button>
      )}
    </div>
  );
};

export default NotFound;
